import {
  getBookingsDisplaySettingsByWidget as publicGetBookingsDisplaySettingsByWidget,
  upsertBookingsDisplaySettings as publicUpsertBookingsDisplaySettings,
  deleteBookingsDisplaySettings as publicDeleteBookingsDisplaySettings,
} from './bookings-display-settings-v1-bookings-display-settings-display-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getBookingsDisplaySettingsByWidget: MaybeContext<
  BuildRESTFunction<typeof publicGetBookingsDisplaySettingsByWidget> &
    typeof publicGetBookingsDisplaySettingsByWidget
> = /*#__PURE__*/ createRESTModule(publicGetBookingsDisplaySettingsByWidget);
/** @internal */
export const upsertBookingsDisplaySettings: MaybeContext<
  BuildRESTFunction<typeof publicUpsertBookingsDisplaySettings> &
    typeof publicUpsertBookingsDisplaySettings
> = /*#__PURE__*/ createRESTModule(publicUpsertBookingsDisplaySettings);
/** @internal */
export const deleteBookingsDisplaySettings: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBookingsDisplaySettings> &
    typeof publicDeleteBookingsDisplaySettings
> = /*#__PURE__*/ createRESTModule(publicDeleteBookingsDisplaySettings);

export {
  WidgetType,
  NotesDisplayMode,
  WebhookIdentityType,
} from './bookings-display-settings-v1-bookings-display-settings-display-settings.universal.js';
export {
  BookingsDisplaySettings,
  BookingsDisplaySettingsWidgetSettingsOneOf,
  SidePanelView,
  NotesSection,
  PriceSection,
  LocationSection,
  AssignedStaffMemberSection,
  RequestedStaffMemberMethodSection,
  ResourcesSection,
  AddOnsSection,
  ExtendedFields,
  GetBookingsDisplaySettingsByWidgetRequest,
  GetBookingsDisplaySettingsByWidgetResponse,
  UpsertBookingsDisplaySettingsRequest,
  UpsertBookingsDisplaySettingsResponse,
  DeleteBookingsDisplaySettingsRequest,
  DeleteBookingsDisplaySettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetBookingsDisplaySettingsByWidgetIdentifiers,
  GetBookingsDisplaySettingsByWidgetOptions,
  UpsertBookingsDisplaySettings,
  UpsertBookingsDisplaySettingsIdentifiers,
} from './bookings-display-settings-v1-bookings-display-settings-display-settings.universal.js';
export {
  WidgetTypeWithLiterals,
  NotesDisplayModeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpsertBookingsDisplaySettingsApplicationErrors,
} from './bookings-display-settings-v1-bookings-display-settings-display-settings.universal.js';
